import Button from "./Button";
interface NextBtnProps {
    canProceed?: boolean;
    progressProcess: (n: number) => void;
}

/**
 * @author cjs
 * @date 2024-09-12 11:26:58
 * @remark 지도만들기 화면 다음 버튼
 * @param props
 * @props NextBtnProps
 *      progressProcess (required) : 지도만들기 과정 페이지 변경 함수
 * @returns PreviousBtn
 */

function NextBtn(props: NextBtnProps) {
    const canClick = props.canProceed ?? true;

    return (
        <Button
            label={"다음"}
            size={"large"}
            background={canClick ? "var(--main-color)" : "#818181"}
            onClick={() => (canClick ? props.progressProcess(1) : null)}
        />
    );
}
export default NextBtn;
